import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { ErrorMessageService } from '@shared/services/error-message.service'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'app-error-message',
  imports: [TranslatePipe],
  templateUrl: './error-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './error-message.component.scss',
})
export class ErrorMessageComponent {
  errorMessageService = inject(ErrorMessageService)
}
